import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { can } from "@src/utils/components/permissions";
import { AppSubNav } from "../AppSubNav";

export const ResourcePlanningNavigation = () => {
  return (
    <AppSubNav>
      {can("planning_read_all") && (
        <NavBar.Item href={{ pathname: "/resource-planning" }}>
          <Trans>Teams view</Trans>
        </NavBar.Item>
      )}
      {can("planning_read_own") && (
        <NavBar.Item href={{ pathname: "/resource-planning/my-week" }}>
          <Trans>My week</Trans>
        </NavBar.Item>
      )}
    </AppSubNav>
  );
};
